module.exports = "<listado-general \r\n  [listado]=\"pages\" \r\n  [titulo]=\"'TEMPLATE_PAGES' | i18next\"\r\n  [urladicional]=\"''\"\r\n  [ocultarNuevo]=\"'true'\"\r\n  [imagenClass]=\"'site-template'\"\r\n  [leyendaListado]=\"'DEFAULT_LEYENDA_LISTADO' | i18next\">\r\n</listado-general>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/siteTemplates/listado.pages.component.html
// module id = ../../../../../src/app/private/siteTemplates/listado.pages.component.html
// module chunks = main